import i18n from 'i18next';

import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentProductHazmat } from '../../hooks';

export const ShipmentProductHazmatSelect = ({
  placeholder = i18n.t('translation:default.fields.hazmatClassDangerous.placeholder'),
  label = i18n.t('translation:default.fields.hazmatClassDangerous.label'),
  rules = [],
  name,
  editMode,
  onChange = false,
  margin = 'mb-0',
  tabIndex,
}) => {
  const { data: options = [], isLoading } = useGetShipmentProductHazmat();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      {...(onChange ? { onChange } : {})}
      tabIndex={tabIndex}
    />
  );
};
